


























































import {Vue, Component, Prop, Watch} from 'vue-property-decorator';
import {BOOKING_STATUS, CLAIM_STATUS, multiNil, nil} from '@/common';
import VendorProfileDialog from '@/components/Views/Vendor/VendorProfileDialog.vue';
import {sortBy, debounce} from 'lodash';
import {DateTime} from 'luxon';
import {Mixins} from 'vue-property-decorator';
import GlobalAlertMixin from '@/mixins/GlobalAlertMixin.vue';
import {FeathersVuexFindAll} from '@/utils';

@Component({
    components: {
        VendorProfileDialog,
    },
})
export default class VendorClaimList extends Mixins(GlobalAlertMixin) {

    public loading: boolean = false;
    public searchLoading: boolean = false;
    @Prop({default: () => undefined})
    public claims!: any[];

    @Prop({default: () => undefined})
    public booking!: any;
    public search: string = '';

    @Watch('search')
    public onSearchChanged(value: string, oldValue: string) {
        this.searchChanged();
    }

    public searchedVendors: any[] = [];

    public iconFor(status) {
        switch (status) {
            case CLAIM_STATUS.ACCEPTED :
                return 'fas fa-check-circle';
            case CLAIM_STATUS.REJECTED :
                return 'fas fa-times-circle';
            case CLAIM_STATUS.ASSIGNED:
                return 'fas fa-clipboard-check';
            default:
                return 'fas fa-question-circle';
        }
    }

    public isRequested(claim) {
        return claim.vendor === this.booking.requestedVendor;
    }

    public isAssigned(claim) {
        return claim.status === CLAIM_STATUS.ASSIGNED;
    }

    public isRejected(claim) {
        return claim.status === CLAIM_STATUS.REJECTED;
    }

    public isAccepted(claim) {
        return claim.status === CLAIM_STATUS.ACCEPTED;
    }

    public colorFor(status) {
        switch (status) {
            case CLAIM_STATUS.ACCEPTED :
                return 'success';
            case CLAIM_STATUS.REJECTED :
                return 'error';
            case CLAIM_STATUS.ASSIGNED :
                return 'warning';
            default:
                return 'grey lighten-1';
        }
    }

    public textFor(claim) {
        const relativeDate = DateTime.fromISO(claim.updatedAt).toLocal().toLocaleString(DateTime.DATETIME_MED);
        switch (claim.status) {
            case CLAIM_STATUS.ACCEPTED :
                return `Accepted ${relativeDate}`;
            case CLAIM_STATUS.REJECTED :
                return `Rejected ${relativeDate}`;
            case CLAIM_STATUS.ASSIGNED:
                return `Assigned ${relativeDate}`;
            default:
                return 'No Response';
        }
    }

    public async respondToBooking(claim, response) {
        if (!nil(this.booking)) {
            this.loading = true;
            const {Booking} = this.$FeathersVuex;
            claim.status = response ? CLAIM_STATUS.ASSIGNED : CLAIM_STATUS.REJECTED;
            await claim.save();
            this.showAlert('This pro will get an email notifying them of their assignment', 'success');
            const b = await Booking.get(this.booking._id);
            this.$emit('onBookingUpdated', b);
            this.$emit('onClaimUpdated', claim);
            this.loading = false;
        }
    }

    public async generateClaimAndAssign(vendor) {
        if (!nil(this.booking)) {
            this.loading = true;
            const {VendorClaim} = this.$FeathersVuex;
            const vc = new VendorClaim({
                vendor: vendor._id,
                booking: this.booking._id,
                status: CLAIM_STATUS.ASSIGNED,
            });
            try {
                // await vc.create();
                await this.respondToBooking(vc, true);
                this.search = '';
            } catch (e) {
                const {message} = e;
                this.showAlert(message, 'error');
                this.loading = false;
            }
        }
    }

    public async onBook(vendor) {
        if (!nil(this.booking)) {
            const {VendorClaim, Booking} = this.$FeathersVuex;
            // this.booking.assignedVendor = vendor._id;
            const claims = await VendorClaim.find({query: {booking: this.booking._id, vendor: vendor._id}});
            const [claim] = claims.data;
            await this.respondToBooking(claim, true);
        }
    }

    public async searchVendors() {
        this.searchLoading = true;
        if (nil(this.search, true)) {
            this.searchedVendors = [];
            this.searchLoading = false;
        } else {
            const found = await FeathersVuexFindAll(this.$FeathersVuex.Vendor, {query: this.addToQuery()}, true);
            const existing = this.searchedClaims.map((x) => x.vendor);
            this.searchedVendors = found.filter((x) => existing.indexOf(x._id) === -1 && x.tierModel.priceSort >= this.booking.purchasableModel.tierModel.priceSort);
            this.searchLoading = false;
        }
    }

    public claimNote(claim) {
        if (nil(this.booking)) {
            return '';
        }
        if (nil(this.booking.requestedVendor)) {
            return '';
        }
        if (this.booking.requestedVendor === claim.vendor) {
            return '(Requested by customer)';
        }
    }

    public get searchedClaims() {
        let list = this.claims;
        if (!nil(this.search, true)) {
            list = this.claims.filter((x) => {
                return x.vendorModel.firstName.toLowerCase().indexOf(this.search.toLowerCase()) > -1 || x.vendorModel.lastName.toLowerCase().indexOf(this.search.toLowerCase()) > -1;
            });
        }
        return sortBy(list, 'distance');
    }

    public get waitingForRequestedVendor() {
        if (nil(this.booking)) {
            return false;
        }
        return this.booking.status === BOOKING_STATUS.WAITING_ON_REQUESTED_PRO;
    }

    public get mobileMode() {
        return !this.isSM(true);
    }

    private searchChanged = debounce(() => {
        this.searchVendors();
    }, 850);

    public addToQuery() {
        if (
            nil(this.booking) ||
            multiNil(this, 'booking.purchasableModel.tier')
        ) {
            return {};
        }
        return {
            serviceTypes: {$in: this.booking.purchasableModel.serviceTypes},
            ...this.searchQuery,
        };
    }

    private get isCancelled() {
        if (nil(this.booking)) return false;
        return this.booking.status === BOOKING_STATUS.CANCELLED;
    }

    private get searchQuery() {
        return nil(this.search) || this.search === '' ? undefined : {
            $or: [
                {firstName: {$search: this.search.toString()}},
                {lastName: {$search: this.search.toString()}},
                {email: {$search: this.search.toString()}},
            ],
        };
    }
}
